import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          redirect: "chart/service-report",
          component: () => import('@/views/dashboard/Home'),
          children: [
            {
              path: 'chart/service-report',
              component: () => import('@/views/dashboard/cards/ServiceReportCard'),
            },
            {
              path: 'chart/log-book',
              component: () => import('@/views/dashboard/cards/LogBookCard'),
            },
            {
              path: 'chart/customer',
              component: () => import('@/views/dashboard/cards/CustomerCard'),
            },
          ],
        },
        // Pages
        {
          name: 'Customers',
          path: 'pages/customers',
          component: () => import('@/views/dashboard/pages/Customers'),
        },
        {
          name: 'Systems',
          path: 'pages/systems',
          component: () => import('@/views/dashboard/pages/Systems'),
        },
        {
          name: 'Service Reports',
          path: 'pages/service-reports',
          component: () => import('@/views/dashboard/pages/ServiceReports'),
        },
        {
          name: 'Log Books',
          path: 'pages/log-books',
          component: () => import('@/views/dashboard/pages/LogBooks'),
        },
        {
          name: 'User Profile',
          path: 'pages/user',
          component: () => import('@/views/dashboard/pages/UserProfile'),
        },
        {
          name: 'Notifications',
          path: 'components/notifications',
          component: () => import('@/views/dashboard/component/Notifications'),
        },
        {
          name: 'Icons',
          path: 'components/icons',
          component: () => import('@/views/dashboard/component/Icons'),
        },
        {
          name: 'Typography',
          path: 'components/typography',
          component: () => import('@/views/dashboard/component/Typography'),
        },
        // Tables
        {
          name: 'Regular Tables',
          path: 'tables/regular-tables',
          component: () => import('@/views/dashboard/tables/RegularTables'),
        },
        // Maps
        {
          name: 'Google Maps',
          path: 'maps/google-maps',
          component: () => import('@/views/dashboard/maps/GoogleMaps'),
        },
      ],
    },
  ],
})
